import Optativas from './Optativas';

export default Optativas;